import Resource from "./resource";
import Permission from "./permission";
import ProjectedTeamReferenceDataItem from "./projectedTeamReferenceDataItem";
import UserPermissionRestriction from "./userPermissionRestriction";
import Permissions from "./permissions";

export class UserPermissionSetResource extends Resource {
    Permissions: Permissions;
    Teams: ProjectedTeamReferenceDataItem[];
}

export default UserPermissionSetResource;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/userPermissionSetResource.ts